import { type RefObject, useEffect, useState } from "react";

export const useOnScreen = (
	ref: RefObject<HTMLElement | null>,
	enabled = true,
): boolean => {
	const [isOnScreen, setIsOnScreen] = useState(true);

	useEffect(() => {
		const el = ref.current;
		if (!el || !enabled) return;

		const observer = new IntersectionObserver(
			([entry]) => setIsOnScreen(entry.isIntersecting),
			{ threshold: 0 },
		);
		observer.observe(el);
		return () => observer.disconnect();
	}, [ref, enabled]);

	return isOnScreen;
};
